export default {
  HEADING: 'KV-Dienste so einfach organisieren wie online shoppen? Das geht.',
  SUBHEADING: 'arztpool setzt einen neuen Standard und unterstützt Sie dabei, Ihre Praxisabläufe zu vereinfachen.',
  CLOSE: 'Schließen',
  PARTNERBUTTON: 'Ich möchte KV-Dienste vertreten lassen.',
  SUBSTITUTEBUTTON: 'Ich möchte KV-Dienste übernehmen.',
};
